import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const carouselPlaybackButtonStyles = tv({
    slots: {
        button: `
      iris:group
      iris:cursor-pointer
      iris:overflow-hidden
      iris:rounded-(--comp-size-radius-carousel-button)
      iris:disabled:cursor-not-allowed
    `,
        wrapper: `
      iris:flex
      iris:h-(--comp-size-box-carousel-button)
      iris:w-(--comp-size-box-carousel-button)
      iris:items-center
      iris:justify-center
      iris:transition-all
      iris:duration-(--comp-motion-duration-carousel-button)
      iris:ease-(--comp-motion-easing-carousel-button)
    `,
        icon: `
      iris:size-(--comp-size-icon-carousel-button)
      iris:text-(--comp-color-content-carousel-button-icon-rest)
      iris:transition-all
      iris:duration-(--comp-motion-duration-carousel-button)
      iris:ease-(--comp-motion-easing-carousel-button)
    `,
    },
    variants: {
        variant: {
            floating: {
                button: `
            iris:bg-(--comp-color-background-carousel-button-rest)
            iris:shadow-elevation-02
        `,
                wrapper: `
            iris:group-hover:bg-(--comp-color-background-carousel-button-hover)
            iris:group-active:bg-(--comp-color-background-carousel-button-pressed)
        `,
                icon: `
            iris:text-(--comp-color-content-carousel-button-icon-rest)
            iris:group-hover:text-(--comp-color-content-carousel-button-icon-hover)
            iris:group-active:text-(--comp-color-content-carousel-button-icon-pressed)
        `,
            },
            "in-page": {
                button: `
            iris:border
            iris:border-(length:--comp-size-border-carousel-button)
            iris:border-(--comp-color-border-carousel-button-rest)
            iris:bg-(--comp-color-background-carousel-button-rest)
            iris:hover:border-(--comp-color-border-carousel-button-hover)
            iris:active:border-(--comp-color-border-carousel-button-pressed)
        `,
                wrapper: `
            iris:group-hover:bg-(--comp-color-background-carousel-button-hover)
            iris:group-active:bg-(--comp-color-background-carousel-button-pressed)
        `,
                icon: `
            iris:text-(--comp-color-content-carousel-button-icon-rest)
            iris:group-hover:text-(--comp-color-content-carousel-button-icon-hover)
            iris:group-active:text-(--comp-color-content-carousel-button-icon-pressed)
        `,
            },
            "floating-over-image": {
                button: `
            iris:border
            iris:border-(length:--comp-size-border-carousel-button)
            iris:border-(--comp-color-border-carousel-button-image-rest)

            iris:shadow-elevation-02
            iris:hover:border-(--comp-color-border-carousel-button-image-hover)
            iris:active:border-(--comp-color-border-carousel-button-image-pressed)
        `,
                wrapper: `
            iris:bg-(--comp-color-background-carousel-button-image-rest)
            iris:group-hover:bg-(--comp-color-background-carousel-button-image-hover)
            iris:group-active:bg-(--comp-color-background-carousel-button-image-pressed)
        `,
                icon: `
            iris:text-(--comp-color-content-carousel-button-image-icon-rest)
            iris:group-hover:text-(--comp-color-content-carousel-button-image-icon-hover)
            iris:group-active:text-(--comp-color-content-carousel-button-image-icon-pressed)
        `,
            },
        },
        inverse: {
            true: {
                button: focusStyles.inverse,
            },
            false: { button: focusStyles.default },
        },
        type: {
            play: {
                icon: "iris:pl-(--comp-space-padding-carousel-button-icon-nudge)",
            },
            pause: {},
        },
    },
    compoundVariants: [
        {
            variant: "floating",
            inverse: true,
            class: {
                button: `
            iris:bg-(--comp-color-background-carousel-button-inverse-rest)
        `,
                wrapper: `
            iris:group-hover:bg-(--comp-color-background-carousel-button-inverse-hover)
            iris:group-active:bg-(--comp-color-background-carousel-button-inverse-pressed)
        `,
                icon: `
            iris:text-(--comp-color-content-carousel-button-icon-inverse-rest)
            iris:group-hover:text-(--comp-color-content-carousel-button-icon-inverse-hover)
            iris:group-active:text-(--comp-color-content-carousel-button-icon-inverse-pressed)
        `,
            },
        },
        {
            variant: "in-page",
            inverse: true,
            class: {
                button: `
            iris:border
            iris:border-(length:--comp-size-border-carousel-button)
            iris:border-(--comp-color-border-carousel-button-rest)
            iris:bg-(--comp-color-background-carousel-button-inverse-rest)
            iris:hover:border-(--comp-color-border-carousel-button-hover)
            iris:active:border-(--comp-color-border-carousel-button-pressed)
        `,
                wrapper: `
            iris:group-hover:bg-(--comp-color-background-carousel-button-inverse-hover)
            iris:group-active:bg-(--comp-color-background-carousel-button-inverse-pressed)
        `,
                icon: ` 
            iris:text-(--comp-color-content-carousel-button-icon-inverse-rest)
            iris:hover:text-(--comp-color-content-carousel-button-icon-inverse-hover)
            iris:active:text-(--comp-color-content-carousel-button-icon-inverse-pressed)
        `,
            },
        },
    ],
    defaultVariants: {
        variant: "floating",
        inverse: false,
        type: "play",
    },
});

export { carouselPlaybackButtonStyles as default };
